<template>
  <a-modal :title="title"
           :width="600"
           :visible="visible"
           :confirmLoading="confirmLoading"
           @ok="handleOk"
           @cancel="handleCancel"
           :cancelText="$t('button.close')">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <mtc-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="label.dictionaryName">
          <a-input v-decorator="['dictName', validatorRules.dictName]"
                   :read-only="checkField('dictName')"
                   @click="openLangModal('dictName', true)"
                   :placeholder="$t('label.pleaseEnterDictionaryName')" />
        </mtc-form-item>
        <mtc-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="label.dictionaryNumber">
          <a-input :placeholder="$t('label.pleaseEnterDictionaryNum')"
                   :disabled="!!model.id"
                   v-decorator.trim="['dictCode', validatorRules.dictCode]" />
        </mtc-form-item>
        <mtc-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="label.description">
          <a-input v-decorator="['description']"
                   :read-only="checkField('description')"
                   @click="openLangModal('description', false)"
                   :placeholder="$t('label.pleaseEnterADescription')" />
        </mtc-form-item>
      </a-form>
    </a-spin>
    <mtc-lang-modal />
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import { addDict, editDict, duplicateCheck } from '@/api/api'
import { mtcLangModalMixin } from '@/mixins/mtcLangModalMixin'
import langInputMixin from '@/mixins/langInputMixin'
import { resetLangFieldMap, setLangInputParams } from '@/utils/langUtils'

export default {
  name: 'DictModal',
  mixins: [mtcLangModalMixin, langInputMixin],
  data() {
    return {
      // 表名
      mainTable: 'sys_dict',
      // 当前页面的数据多语言字段
      langFieldArr: [],
      value: 1,
      title: '操作',
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      // form: this.$form.createForm(this),
      validatorRules: {
        dictName: { rules: [{ required: true, message: this.$t('label.pleaseEnterDictionaryName') }] },
        dictCode: {
          rules: [{ required: true, message: this.$t('label.pleaseEnterDictionaryNum') }, { validator: this.validateDictCode }]
        }
      }
    }
  },
  methods: {
    validateDictCode(rule, value, callback) {
      // 重复校验
      var params = {
        tableName: 'sys_dict',
        fieldName: 'dict_code',
        fieldVal: value,
        dataId: this.model.id
      }
      duplicateCheck(params).then((res) => {
        if (res.success) {
          callback()
        } else {
          callback(res.message)
        }
      })
    },
    handleChange(value) {
      this.model.status = value
    },
    add() {
      this.edit({})
    },
    edit(record) {
      this.getLangForm(this.mainTable)
      if (record.id) {
        this.visiblekey = true
      } else {
        this.visiblekey = false
      }
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'dictName', 'dictCode', 'description'))
      })
    },
    // 确定
    handleOk() {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          values.dictName = (values.dictName || '').trim()
          values.dictCode = (values.dictCode || '').trim()
          values.description = (values.description || '').trim()
          let formData = Object.assign(this.model, values)
          let url
          // 设置数据多语言参数
          formData.sysLanguageList = setLangInputParams(this.mainTable, formData.id)
          console.log(formData)
          if (!this.model.id) {
            url = addDict
          } else {
            url = editDict
          }
          that.confirmLoading = true
          url(formData).then(res => {
            resetLangFieldMap()
            that.$message.success(res.message)
            that.$emit('ok')
          }).finally(() => {
            that.confirmLoading = false
            that.close()
          })
        }
      })
    },
    // 关闭
    handleCancel() {
      this.close()
    },
    close() {
      this.$emit('close')
      this.visible = false
    }
  }
}
</script>